import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';

interface IconMap {
  [iconName: string]: string;
}

const defaultBasePath = '/assets/img/icons/';

/**
 * Utility method to register icons at startup
 */
function provideMatIconRegistry(icons: IconMap, basePath = defaultBasePath): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const registry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    for (const [name, file] of Object.entries(icons)) {
      // this minimizes security issues by only accepting svg files
      if (file.endsWith('.svg')) {
        registry.addSvgIcon(name, sanitizer.bypassSecurityTrustResourceUrl(basePath + file));
      } else {
        console.warn(`Invalid icon file type for ${name}: ${file}`);
      }
    }
  });
}

/**
 * Provides all Material modules and registers custom icons
 */
export function provideMaterialForSharedUi(
  icons: IconMap,
  basePath = defaultBasePath,
): Array<Provider | EnvironmentProviders> {
  return [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    provideMatIconRegistry(icons, basePath),
  ];
}
